import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import "./Preview.css";

function Preview() {
  const { inbox_token } = useParams();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    // Add noindex meta tag
    const metaNoindex = document.createElement("meta");
    metaNoindex.name = "robots";
    metaNoindex.content = "noindex, nofollow";
    document.head.appendChild(metaNoindex);

    return () => {
      // Cleanup: remove meta tag when component unmounts
      const existingMeta = document.querySelector(
        'meta[name="robots"][content="noindex, nofollow"]',
      );
      if (existingMeta) {
        existingMeta.remove();
      }
    };
  }, []);

  useEffect(() => {
    const handleChatwootError = (event) => {
      const { errorType, message, statusCode } = event.detail || {};
      if (errorType === "WIDGET_LOAD_ERROR") {
        console.error("Widget load failed:", message, statusCode);
        setError(true);
        setLoading(false);
      }
    };

    window.addEventListener("chatwoot:error", handleChatwootError);
    return () => {
      window.removeEventListener("chatwoot:error", handleChatwootError);
    };
  }, []);

  useEffect(() => {
    if (!inbox_token) {
      setError(true);
      setLoading(false);
      return;
    }

    // Determine BASE_URL based on URL path
    let BASE_URL;
    if (location.pathname.includes("/preview/dev/")) {
      BASE_URL = "http://localhost:3030";
    } else if (location.pathname.includes("/preview/stage/")) {
      BASE_URL = "https://staging.inquirly.ai";
    } else {
      // /preview/:token - production
      BASE_URL = "https://app.inquirly.ai";
    }

    // Load SDK script dynamically
    const script = document.createElement("script");
    script.src = `${BASE_URL}/packs/js/sdk.js`;
    script.defer = true;
    script.async = true;

    // Handle script load success
    script.onload = function () {
      setLoading(false);

      // Initialize widget
      if (window.chatwootSDK && window.chatwootSDK.run) {
        try {
          window.chatwootSDK.run({
            websiteToken: inbox_token,
            baseUrl: BASE_URL,
          });
        } catch (err) {
          console.error("Failed to initialize widget:", err);
          setError(true);
        }
      } else {
        console.error("Chatwoot SDK not available");
        setError(true);
      }
    };

    // Handle script load error (404 or network error)
    script.onerror = function () {
      setError(true);
      setLoading(false);
    };

    // Append script to document
    const firstScript = document.getElementsByTagName("script")[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }

    // Cleanup function
    return () => {
      // Remove script if component unmounts before it loads
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [inbox_token, location.pathname]);

  if (loading) {
    return (
      <div className="preview-container">
        <div className="preview-loading">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="preview-container">
        <div className="preview-error">
          <h1>404</h1>
          <p>Inbox not found</p>
        </div>
      </div>
    );
  }

  return <div className="preview-container" />;
}

export default Preview;
